import Cargos from '@/models/Cargos'

export default [
  {
    path: '/contato/ligacoes',
    name: 'rota-ligacoes',
    autenticado: true,
    cargo: [Cargos.ATENDENTE, Cargos.LIDER],
    titulo: 'Indicações',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Indicações',
      icon: 'hand-point-up',
    },
    component: () => import(/* webpackChunkName: "contato" */ '../views/ligacoes/Ligacoes.vue'),
  },
]
